import React from "react";

// region Hooks
import useTranslation from "@languages/useTranslation";
// endregion Hooks
// region Languages
import { GlobalMessages } from "@languages/interfaces";
// endregion Languages
// region Styles
import Styled from "./styles";
// endregion Styles

// region Types
interface AccessDeniedProps {
  title?: string;
  message?: string;
}
// endregion Types

const AccessDenied: React.FC<AccessDeniedProps> = ({
  title,
  message
}) => {

  // region Hooks
  const { t } = useTranslation();
  // endregion Hooks

  return (
    <Styled.Container>
      <Styled.Title>
        {title ?? t(GlobalMessages.accessDenied)}
      </Styled.Title>
      <Styled.Message>
        {message ?? t(GlobalMessages.insufficientPermissions)}
      </Styled.Message>
    </Styled.Container>
  );
};

AccessDenied.defaultProps = {
  title: undefined,
  message: undefined
};

export default AccessDenied;